import { FunctionComponent } from 'react'
import { Button } from '@black-bear-energy/rucksack'

export const ResetButton: FunctionComponent<ResetButtonProps> = ({
  onClick,
  disabled,
}) => {
  return (
    <Button
      variant="text"
      size="small"
      onClick={onClick}
      disabled={disabled}
      sx={{
        minWidth: '0',
      }}
    >
      Reset
    </Button>
  )
}

interface ResetButtonProps {
  onClick: () => void
  disabled?: boolean
}
